<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" md="4">
          <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            :items="attendanceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: { DateIOSPicker, GradeClassStudentSelect },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      time: moment().toISOString()
    }
  },
  computed: {
    ...mapState('constant', ['attendanceStatus'])
  },
  mounted() {
    const searchImmediate = !!this.$route.query.searchImmediate
    if (searchImmediate) {
      this.onFilterChanged()
    }
  },
  methods: {
    ...mapActions('attendance', ['setDate']),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },

    onFilterChanged() {
      this.setDate(this.time)

      const params = {
        time: this.time,
        status: this.status,
        grade: get(this.selectedGrade, 'id', ''),
        class: get(this.selectedClass, 'id', ''),
        student: get(this.selectedStudent, 'id', '')
      }

      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
